export default {
  title: 'Pankkitiedot',
  sections: {
    personal_info: 'Henkilötiedot',
    address: 'Osoite',
  },
  labels: {
    account_number: 'Tilinumero',
    routing_number: 'Pankkitunnus',
    email: 'Sähköposti',
    full_name: 'Koko nimi',
    street: 'Katuosoite',
    zip_code: 'Postinumero',
    city: 'Kaupunki',
  },
  tooltip: '{{field}} kopioitu leikepöydälle!',
};
